// extracted by mini-css-extract-plugin
export default {"container":"Cbi1Ut","wrapper":"rIJXR4","logo":"GAuLAO","message":"GT0ZGO","trademarks":"GifXIw","info":"eCJ_1z","mobile":"CrlDCx"};